export const EXAMPLE_COMPONENT = 'temp/EXAMPLE_COMPONENT';
